export const categories = [
  {
    slug: 'football',
    name: '足球',
    icon: 'ri-football-line',
    description: '覆盖英超、西甲、意甲、德甲、法甲、欧冠等全球顶级足球联赛，实时赔率更新，胜平负、让球盘、大小球等多种玩法。',
    matchCount: 128,
    imageSeq: 'category-football-01',
  },
  {
    slug: 'basketball',
    name: '篮球',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA、欧洲联赛等篮球赛事全覆盖，让分盘、大小分、胜分差等丰富投注选项，实时数据同步。',
    matchCount: 86,
    imageSeq: 'category-basketball-01',
  },
  {
    slug: 'tennis',
    name: '网球',
    icon: 'ri-base-station-line',
    description: 'ATP、WTA、大满贯赛事一网打尽，实时比分直播，赛前盘与滚球盘双重选择。',
    matchCount: 54,
    imageSeq: 'category-tennis-01',
  },
  {
    slug: 'esports',
    name: '电竞',
    icon: 'ri-gamepad-line',
    description: 'LOL、DOTA2、CS:GO、王者荣耀等热门电竞赛事，专业数据分析，实时赔率。',
    matchCount: 42,
    imageSeq: 'category-esports-01',
  },
  {
    slug: 'baseball',
    name: '棒球',
    icon: 'ri-boxing-line',
    description: 'MLB、日职棒、韩职棒等全球棒球赛事，丰富的投注市场选择。',
    matchCount: 35,
    imageSeq: 'category-baseball-01',
  },
  {
    slug: 'other',
    name: '更多赛事',
    icon: 'ri-more-line',
    description: '橄榄球、高尔夫、F1赛车、拳击、综合格斗等更多精彩体育赛事竞猜。',
    matchCount: 67,
    imageSeq: 'category-other-01',
  },
];

export const liveEvents = [
  {
    id: 1,
    league: '英超联赛',
    homeTeam: '曼城',
    awayTeam: '阿森纳',
    homeScore: 2,
    awayScore: 1,
    time: '78\'',
    homeOdds: 1.85,
    drawOdds: 3.60,
    awayOdds: 4.20,
    status: 'live',
    category: 'football',
  },
  {
    id: 2,
    league: 'NBA常规赛',
    homeTeam: '洛杉矶湖人',
    awayTeam: '金州勇士',
    homeScore: 98,
    awayScore: 92,
    time: 'Q3 4:21',
    homeOdds: 1.72,
    drawOdds: 0,
    awayOdds: 2.15,
    status: 'live',
    category: 'basketball',
  },
  {
    id: 3,
    league: 'ATP大师赛',
    homeTeam: '德约科维奇',
    awayTeam: '阿尔卡拉斯',
    homeScore: 1,
    awayScore: 1,
    time: 'Set 3',
    homeOdds: 2.10,
    drawOdds: 0,
    awayOdds: 1.75,
    status: 'live',
    category: 'tennis',
  },
  {
    id: 4,
    league: '西甲联赛',
    homeTeam: '皇家马德里',
    awayTeam: '巴塞罗那',
    homeScore: 0,
    awayScore: 0,
    time: '35\'',
    homeOdds: 2.25,
    drawOdds: 3.40,
    awayOdds: 3.10,
    status: 'live',
    category: 'football',
  },
  {
    id: 5,
    league: 'LOL全球总决赛',
    homeTeam: 'T1',
    awayTeam: 'JDG',
    homeScore: 1,
    awayScore: 0,
    time: 'BO3',
    homeOdds: 1.90,
    drawOdds: 0,
    awayOdds: 1.90,
    status: 'live',
    category: 'esports',
  },
  {
    id: 6,
    league: '德甲联赛',
    homeTeam: '拜仁慕尼黑',
    awayTeam: '多特蒙德',
    homeScore: 3,
    awayScore: 2,
    time: '82\'',
    homeOdds: 1.55,
    drawOdds: 4.50,
    awayOdds: 5.80,
    status: 'live',
    category: 'football',
  },
];

export const upcomingEvents = [
  {
    id: 7,
    league: '欧冠决赛',
    homeTeam: '曼城',
    awayTeam: '皇家马德里',
    startTime: '2026-08-10 03:00',
    homeOdds: 1.95,
    drawOdds: 3.50,
    awayOdds: 3.80,
    category: 'football',
  },
  {
    id: 8,
    league: 'NBA总决赛 G3',
    homeTeam: '波士顿凯尔特人',
    awayTeam: '丹佛掘金',
    startTime: '2026-08-09 08:30',
    homeOdds: 1.68,
    drawOdds: 0,
    awayOdds: 2.25,
    category: 'basketball',
  },
  {
    id: 9,
    league: '温网男单决赛',
    homeTeam: '辛纳',
    awayTeam: '梅德韦杰夫',
    startTime: '2026-08-11 21:00',
    homeOdds: 1.60,
    drawOdds: 0,
    awayOdds: 2.40,
    category: 'tennis',
  },
  {
    id: 10,
    league: 'CS:GO Major',
    homeTeam: 'FaZe Clan',
    awayTeam: 'Natus Vincere',
    startTime: '2026-08-12 18:00',
    homeOdds: 2.05,
    drawOdds: 0,
    awayOdds: 1.78,
    category: 'esports',
  },
];

export const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '持有正规博彩牌照，采用银行级加密技术，全方位保障用户资金与信息安全。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '实时赔率',
    description: '赔率实时更新，紧跟全球市场变化，确保用户始终获得最具竞争力的赔率。',
  },
  {
    icon: 'ri-bank-card-line',
    title: '存取便捷',
    description: '支持多种支付方式，充值秒到账，提现快速审核，7×24小时无忧。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '全天客服',
    description: '专业客服团队7×24小时在线，多语言支持，随时为用户解答疑问。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端兼容',
    description: '支持PC网页、手机APP、平板等多终端访问，随时随地享受竞猜乐趣。',
  },
  {
    icon: 'ri-gift-line',
    title: '丰厚礼遇',
    description: '新用户注册即享专属欢迎礼包，老用户尊享VIP权益，多重优惠不停歇。',
  },
];

export const faqItems = [
  {
    question: 'bob体育如何注册账号？',
    answer: '点击页面右上角"注册"按钮，填写手机号或邮箱，设置密码，完成短信或邮箱验证即可成功注册bob体育账号。整个注册过程仅需1分钟。',
  },
  {
    question: 'bob体育支持哪些充值方式？',
    answer: 'bob体育支持多种充值方式，包括银行卡转账、支付宝、微信支付、USDT数字货币等。充值实时到账，不收取任何手续费。',
  },
  {
    question: '提现需要多长时间到账？',
    answer: 'bob体育提现审核通常在30分钟内完成，审核通过后，银行卡提现1-3个工作日到账，数字货币提现实时到账。VIP用户享受优先处理通道。',
  },
  {
    question: 'bob体育赔率是否具有竞争力？',
    answer: 'bob体育采用国际顶级赔率系统，赔率实时对标全球主流博彩市场，确保为用户提供极具竞争力的赔率。在足球、篮球等主流赛事中，我们的赔率长期处于行业领先水平。',
  },
  {
    question: 'bob体育App如何下载？',
    answer: '您可以在bob体育官网首页找到App下载入口，支持iOS和Android双平台。iOS用户可通过TestFlight或企业签名安装，Android用户可直接下载APK安装包。',
  },
];

export const siteNav = {
  main: [
    { label: '首页', href: '/' },
    { label: '赛事竞猜', href: '/category/football' },
    { label: '体育资讯', href: '/articles' },
    { label: '关于我们', href: '/about' },
  ],
};